export default "__VITE_ASSET__BNWLbITQ__"